<template>
  <div class="manualBinding">
    <div class="barcodeBox">
      <div class="key">试管条码号</div>
      <div class="value">
        <input
          type="tel"
          placeholder="请输入试管条码号"
          v-model="code"
        >
      </div>
    </div>
    <div
      class="nextBtn"
      v-if="btnFlag"
      @click="goBindingUserInfo"
    >下一步</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: "",
      type: "",
      btnFlag: true,
    };
  },
  created() {
    this.subOrderNo = this.$route.query.subOrderNo;
    this.type = this.$route.query.type;
    if (this.type == 2 && !localStorage.getItem("systemUserInfo")) {
      localStorage.setItem("redirect", location.hash.slice(1));
      this.$router.replace({
        name: "nurseLogin",
      });
    } else if (!this.type) {
      if (!localStorage.getItem("userInfo")) {
        this.$goLogin();
      }
    }
    if (!this.$store.state.wxConfigFlag) this.$wxConfig();
  },
  methods: {
    goBindingUserInfo() {
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        if (!this.code) {
          this.$toots("请输入条码号");
          return;
        }
        if (localStorage.getItem("multipleChoiceArr"))
          this.bindMultipleChoice(this.code);
        else this.$bindBox(this.subOrderNo, this.code, this.type);
      }
    },
    // 一个条码号绑定多个项目
    bindMultipleChoice(barCode) {
      this.$http.get(`/detectBox/getByBarCode/${barCode}`).then((res) => {
        if (res.data.code == 200) {
          let barCodeInfo = res.data.data;
          if (barCodeInfo.subOrderNo) {
            this.$toots("当前条码号已绑定");
            return;
          }
          let list = JSON.parse(localStorage.getItem("multipleChoiceArr"));
          let newList = [];
          for (let i = 0; i < list.length; i++) {
            if (i == 0) {
              newList.push({
                barCode: barCode,
                subOrderNo: list[i],
                id: barCodeInfo.id,
              });
            } else
              newList.push({
                barCode: barCode,
                subOrderNo: list[i],
              });
          }
          this.$loading("提交中");
          this.$http
            .post(`/detectBox/batchBindBox`, newList, {
              qs: "no",
            })
            .then((res) => {
              if (res.data.code == 200) {
                localStorage.removeItem("multipleChoiceArr");
                this.$tootsSuccess("保存成功");
                setTimeout(() => {
                  this.$router.replace({
                    name: "MyTesting",
                  });
                }, 1500);
              } else this.$toots(res.data.msg);
            })
            .catch((err) => {
              this.$toots("系统正在升级，请稍后");
            });
        }
      });
    },
  },
  mounted() {
    let winh = document.body.clientHeight; // 取窗口可视范围的高度
    window.addEventListener("resize", () => {
      if (document.body.clientHeight < winh) {
        this.btnFlag = false; //隐藏按钮
      } else {
        this.btnFlag = true; //显示按钮
      }
    });
  },
};
</script>

<style lang='less' scoped>
.manualBinding {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 110px 40px 90px 40px;
  background-color: #fff;
  height: 100%;
  .barcodeBox {
    .key {
      font-size: 36px;
      line-height: 54px;
      font-weight: 700;
    }
    .value {
      border-bottom: 1px solid #eee;
      height: 100px;
      input {
        font-size: 30px;
        margin-top: 40px;
        width: 100%;
      }
      input::placeholder {
        font-size: 30px;
        color: #cccccc;
      }
    }
  }
  .nextBtn {
    width: 100%;
    height: 88px;
    background: #1968a8;
    color: #fff;
    text-align: center;
    line-height: 88px;
    border-radius: 88px;
    font-size: 30px;
  }
}
</style>
